import {request} from '@/utils/http';

let combinationList = '/fronted/goods_combination/list';
let combinationDetail = '/fronted/goods_combination/detail'


export function GET_COMBINATIONLIST(params){
  return request(combinationList,'get',params)
}
export function GET_COMBINATIONDETAIL(params){
  return request(combinationDetail,'get',params)
}



// WEBPACK FOOTER //
// ./src/api/combination.api.js